module.exports = __webpack_public_path__ + "static/media/Milex-Cube-Pessary-Instructions-for-Use@3x.7314ed95.jpg";